// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.name-lenght {
  overflow: hidden;
  max-width: 20ch;
}

.banner {
  width: 100vw;
  max-height: 210px;
  object-fit: contain;
  object-position: top;
}

.card-content {
  padding-top: 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/client-events/client-events.page.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;AACF;;AAEA;EACE,gBAAA;AACF","sourcesContent":[".name-lenght {\n  overflow: hidden;\n  max-width: 20ch;\n}\n\n.banner {\n  width: 100vw;\n  max-height: 210px;\n  object-fit: contain;\n  object-position: top;\n}\n\n.card-content {\n  padding-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
